import { type FC } from "react";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "../types/props";
import { getScormFilters } from "./scormFilters";
import { type ScormFiltersEnum } from "../../../features/Library/SCORM/types/models";

export interface ScormFilterFormForPacksProps extends FilterFormPropsBase<ScormFiltersEnum> {}

const ScormFilterFormForPacks: FC<ScormFilterFormForPacksProps> = ({
  filterOptions,
  filter,
  updateFilter,
  onValidationChange,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getScormFilters(false)}
    onValidationChange={onValidationChange}
  />
);

export default ScormFilterFormForPacks;
